import ListContent from '../component/content/ListContent';
const List = () => {
    return (
        <ListContent />
    )
};

export default List;